export default __webpack_public_path__ + "static/media/chart2.cc5f4c82.png";